import React, { useState, useEffect, useMemo, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Card, Form, Button, Table, Row, Col, Alert, InputGroup, Modal, Badge, OverlayTrigger, Tooltip,}from "react-bootstrap";
import { BarraBusquedaSugerida, respuestaBusqueda,}from "../../BarraBusqueda/BarraBusquedaSugerida";
import apiFc from "../../../services/APIFc";
import { AlertDialogInterface } from "../../common/Interfaces";
import { decryptData } from "../../../functions/cryptoUtils";
import { useSelector } from "react-redux";
import { formatearPrecio, StockLevel } from "../../../functions/Procedimientos";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import { Snackbar } from "@mui/material";
import Select, { ActionMeta, SingleValue } from "react-select";
import InputCarritoCompra from "../../common/InputCarritoCompra";

interface Producto {
  id?: number;
  codigo: string;
  detalle: string;
  precio: number;
  precioSugerido1?: number;
  precioSugerido2?: number;
  precioSugeridoSeleccionado?: "sug1" | "sug2";
  cantidad: number;
  esExterno: boolean;
  presupuestoRenglonId?: number;
  iva?: number;
  mostrarConIVA?: boolean;
}

interface Presupuesto {
  id?: number;
  fechaCreacion?: string;
  fechaValidez: string;
  descripcion: string;
  clienteDescripcion: string;
  clienteCodigo?: number;
  bonificacionGeneral: number;
  fletePrecio: any;
  observacionPie: string;
  observacionInterna?: string;
  estado?: {
    id: number;
    descripcion: string;
    activo: boolean;
  };
  renglones: Array<{
    id?: number;
    articuloCodigo: string | null;
    productoCodigo: string | null;
    productoDetalle: string;
    productoPrecioLista: number;
    productoDescuento: number | null;
    cantidad: number;
    cantidadEntregada?: number;
  }>;
}

const PresupuestadorEdicion = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const inputRef = useRef<HTMLInputElement>(null);
  const id = queryParams.get("id");
  const navigate = useNavigate();
  const encryptedUser = useSelector((store: any) => store.authreducer.user);
  const user = useMemo(() => decryptData(encryptedUser), [encryptedUser]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [showModalProducto, setShowModalProducto] = useState(false);
  const [productoEditando, setProductoEditando] = useState<Producto | null>(null);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [busquedaProductos, setBusquedaProductos] = useState<string>("");
  const [resultadosBusqueda, setResultadosBusqueda] = useState<any[]>([]);
  const [eliminandoRenglon, setEliminandoRenglon] = useState<number | null>(null);
  const [estado, setEstado] = useState<
    Array<{
      id: number;
      descripcion: string;
      activo: boolean;
    }>
  >([]);
  const [editingPrice, setEditingPrice] = useState(false);
  const [priceInputValue, setPriceInputValue] = useState("");
  // aca le seteo al presupuesto porque no se como se va a llenar cuando se genera uno nuevo, si desde la misma vista tendria que venir cierta data (la fecha por ejemplo)
  const formatDateToInput = (date: any) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const [presupuesto, setPresupuesto] = useState<Presupuesto>({
    fechaCreacion: formatDateToInput(new Date()), // Fecha actual formateada
    fechaValidez: formatDateToInput(
      new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
    ), // 7 días después
    descripcion: "",
    clienteDescripcion: "",
    clienteCodigo: user?.clienteCodigo || undefined,
    bonificacionGeneral: 0,
    fletePrecio: 0,
    observacionPie: "",
    renglones: [],
    estado: {
      id: 1,
      descripcion: "Borrador",
      activo: true,
    },
  });



  const estadoOptions = estado.map((est) => ({
    value: est.id,
    label: est.descripcion,
    // isDisabled: !est.activo,
  }));

  const selectedOption = estadoOptions.find(
    (option) => option.value === presupuesto.estado?.id
  );

  const [alertDialog, setAlertDialog] = useState<AlertDialogInterface>({
    id: "1",
    visible: false,
    severity: "success",
    timeOut: 2000,
    cabecera: "Éxito!",
    texto: "Operación realizada con éxito.",
  });
  function Mensaje() {
    const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
      props,
      ref
    ) {
      return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const handleClose = (
      event?: React.SyntheticEvent | Event,
      reason?: string
    ) => {
      if (reason === "clickaway") {
        return;
      }
      setAlertDialog({ ...alertDialog, visible: false });
    };
    return (
      <Snackbar
        open={alertDialog.visible}
        autoHideDuration={alertDialog.timeOut}
        onClose={handleClose}
        //Aca decido si es mobile muestro arriba el cartelito, sino abajo
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleClose}
          severity={alertDialog.severity == "success" ? "success" : "warning"}
          sx={{ width: "100%" }}
        >
          <strong>{alertDialog.cabecera} </strong> {alertDialog.texto}
        </Alert>
      </Snackbar>
    );
  }

  const editarProducto = (renglon: any) => {
    // Buscar el producto completo en los resultados o en los renglones para obtener todos los datos
    const productoCompleto =
      resultadosBusqueda.find(
        (p) => p.articuloCodigo === renglon.articuloCodigo
      ) || presupuesto.renglones.find((p) => p.id === renglon.id);

    setProductoEditando({
      id: renglon.id,
      codigo: renglon.articuloCodigo || renglon.productoCodigo || "",
      detalle: renglon.productoDetalle,
      precio: renglon.productoPrecioLista,
      precioSugerido1:
        productoCompleto?.articuloPrecioVentaSug1 ||
        productoCompleto?.precioSugerido1,
      precioSugerido2:
        productoCompleto?.articuloPrecioVentaSug2 ||
        productoCompleto?.precioSugerido2,
      precioSugeridoSeleccionado: renglon.precioSugeridoSeleccionado,
      iva: productoCompleto?.articuloTasaIVA || productoCompleto?.iva,
      mostrarConIVA: user?.clienteConfiguracionMostrarIVA,
      cantidad: renglon.cantidad,
      esExterno: !renglon.articuloCodigo,
      presupuestoRenglonId: renglon.id,
    });
    setModoEdicion(true);
    setShowModalProducto(true);
  };

  // Cargar presupuesto
  const cargarPresupuesto = async () => {
    setLoading(true);
    if (id) {
      apiFc
        .get(`/web/presupuestos/${id}`)
        .then((response) => {
          setPresupuesto({
            ...response.data,
            fechaCreacion: formatDateToInput(response.data.fechaCreacion),
            fechaValidez: formatDateToInput(response.data.fechaValidez),
          });
        })
        .catch((err) => setError("Error al cargar el presupuesto"))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  };

  //cargar estado del presupuesto
  const cargarEstado = async () => {
    setLoading(true);
    if (id) {
      apiFc
        .get(`/web/presupuestos/status`)
        .then((response) => setEstado(response.data))
        .catch((err) => setError("Error al cargar el estado"))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  };

  // Cargar datos iniciales
  useEffect(() => {
    cargarPresupuesto();
    cargarEstado();
  }, [id]);

  // Buscar productos en la ferre (tengo la barra con un error, me busca un producto atrasado siempre, o me trae cualquier cosa la lista)
  const buscarProductos = async (termino: string) => {
    const terminoBusqueda = String(termino).trim();
    setBusquedaProductos(terminoBusqueda); // Actualiza el estado con el término buscado
  
    if (!terminoBusqueda) {
      setResultadosBusqueda([]);
      return;
    }
  
    try {
      const response = await apiFc.get(
        `/web/articulos/consulta?filter=${terminoBusqueda}&rows=500`
      );
  
      if (response.data.length > 0) {
        setResultadosBusqueda(response.data);
      } else {
        const sugerencias = await apiFc.get(
          `/web/articulos/consulta/sugeridos?filter=${terminoBusqueda}`
        );
        setResultadosBusqueda(sugerencias.data);
      }
    } catch (err) {
      setAlertDialog({
        ...alertDialog,
        visible: true,
        cabecera: "Error buscando artículos",
        texto: "Ocurrió un error al buscar los artículos.",
        severity: "warning",
      });
      setResultadosBusqueda([]);
    }
  };
  // Seleccionar producto de los resultados
  const seleccionarProducto = (
    producto: any,
    precioSugerido: "sug1" | "sug2" = "sug1"
  ) => {
    if (!producto) return;
    setResultadosBusqueda([producto]);
    
    setProductoEditando({
      codigo: producto.articuloCodigo,
      detalle: producto.articuloDescripcion,
      precio:
        precioSugerido === "sug1"
          ? producto.articuloPrecioVentaSug1
          : producto.articuloPrecioVentaSug2,
      precioSugerido1: producto.articuloPrecioVentaSug1,
      precioSugerido2: producto.articuloPrecioVentaSug2,
      precioSugeridoSeleccionado: precioSugerido,
      iva: producto.articuloTasaIVA,
      mostrarConIVA: user?.clienteConfiguracionMostrarIVA,
      cantidad: 1,
      esExterno: false,
    });
  
    setBusquedaProductos(producto.articuloDescripcion); 
    setShowModalProducto(true);
  };

  // Guardar nuevo producto
  const guardarProducto = async () => {
    if (!productoEditando) return;

    // Validación básica para productos externos
    if (productoEditando.esExterno) {
      if (!productoEditando.detalle || productoEditando.detalle.trim() === "") {
        setError("La descripción del producto es obligatoria");
        return;
      }
      if (productoEditando.precio <= 0) {
        setError("El precio debe ser mayor a cero");
        return;
      }
    }

    const presupuestoId = parseInt(id || "0");
    if (!presupuestoId) {
      setError("No se pudo identificar el presupuesto");
      return;
    }

    const payload = {
      ...(modoEdicion &&
        productoEditando.presupuestoRenglonId && {
          id: productoEditando.presupuestoRenglonId,
        }),
      articuloCodigo: productoEditando.esExterno
        ? null
        : productoEditando.codigo,
      productoCodigo: productoEditando.esExterno
        ? productoEditando.codigo
        : null,
      productoDetalle: productoEditando.detalle,
      productoPrecioLista: productoEditando.precio,
      productoDescuento: 0,
      cantidad: productoEditando.cantidad,
      ...(productoEditando.precioSugeridoSeleccionado && {
        precioSugeridoSeleccionado: productoEditando.precioSugeridoSeleccionado,
      }),
    };

    try {
      // Siempre usa el mismo endpoint, independientemente de si es creación o edición
      const response = await apiFc.post(
        `/web/presupuestos/${presupuestoId}/line`,
        payload
      );

      setAlertDialog({
        ...alertDialog,
        visible: true,
        cabecera: "Producto agregado",
        texto: ``,
        severity: "success",
      });
      cargarPresupuesto();
      setShowModalProducto(false);
      setProductoEditando(null);
      setModoEdicion(false);
    } catch (err: any) {
      setAlertDialog({
        ...alertDialog,
        visible: true,
        cabecera: "Error agregando articulo",
        texto: `El articulo  ${
          modoEdicion ? "actualizar" : "guardar"
        } producto: ${err.response?.data?.message || err.message}`,
        severity: "warning",
      });
      // setError(
      //   `Error al ${modoEdicion ? "actualizar" : "guardar"} producto: ${
      //     err.response?.data?.message || err.message
      //   }`
      // );
    }
  };

  // Eliminar producto
  const eliminarProducto = (presupuestoRenglonId: number | undefined) => {
    if (!id) {
      setAlertDialog({
        ...alertDialog,
        visible: true,
        cabecera: "No se ha seleccionado un presupuesto válido",
        texto: ``,
        severity: "warning",
      });
      // setError("No se ha seleccionado un presupuesto válido");
      return;
    }
    if (presupuestoRenglonId === undefined) {
      setAlertDialog({
        ...alertDialog,
        visible: true,
        cabecera: "El producto no tiene un ID válido",
        texto: ``,
        severity: "warning",
      });
      // setError("El producto no tiene un ID válido");
      return;
    }
    setEliminandoRenglon(presupuestoRenglonId);
    apiFc
      .post(`/web/presupuestos/${id}/line/${presupuestoRenglonId}/delete`)
      .then(() => {
        setAlertDialog({
          ...alertDialog,
          visible: true,
          cabecera: "Producto eliminado correctamente",
          texto: ``,
          severity: "success",
        });
        setPresupuesto((prev) => ({
          ...prev,
          renglones: prev.renglones.filter(
            (r) => r.id !== presupuestoRenglonId
          ),
        }));
      })
      .catch((err) => {
        let errorMessage = "Error al eliminar el producto";
        if (err.response?.status === 404)
          errorMessage = "El producto no existe o ya fue eliminado";
        if (err.response?.status === 403)
          errorMessage = "No tiene permisos para esta acción";
        setAlertDialog({
          ...alertDialog,
          visible: true,
          cabecera: "",
          texto: `${errorMessage}`,
          severity: "warning",
        });
      })
      .finally(() => {
        setEliminandoRenglon(null);
      });
  };

  const guardarPresupuesto = async () => {
    if (!id) {
      setAlertDialog({
        ...alertDialog,
        visible: true,
        cabecera: "No se ha seleccionado un presupuesto válido",
        texto: ``,
        severity: "warning",
      });
      return false;
    }

    setLoading(true);

    const payload = {
      fechaCreacion: presupuesto.fechaCreacion,
      fechaValidez: presupuesto.fechaValidez,
      descripcion: presupuesto.descripcion,
      clienteDescripcion: presupuesto.clienteDescripcion,
      clienteCodigo: presupuesto.clienteCodigo,
      bonificacionGeneral: presupuesto.bonificacionGeneral,
      fletePrecio: presupuesto.fletePrecio,
      observacionPie: presupuesto.observacionPie,
      observacionInterna: presupuesto.observacionInterna,
      id: presupuesto.id,
      estado: presupuesto.estado,
      renglones: presupuesto.renglones,
    };

    try {
      const response = await apiFc.post(`/web/presupuestos/${id}`, payload);
      setAlertDialog({
        ...alertDialog,
        visible: true,
        cabecera: "Producto guardado correctamente",
        texto: ``,
        severity: "success",
      });
      setPresupuesto((prev) => ({
        ...prev,
        ...response.data,
      }));
      return true;
    } catch (err: any) {
      const errorMsg =
        err.response?.data?.message ||
        err.message ||
        "Error al guardar el presupuesto";
      setError(`Error: ${errorMsg}`);
      return false;
    } finally {
      setLoading(false);
    }
  };

  // Función para guardar e imprimir
  const guardarEImprimir = async () => {
    const guardadoExitoso = await guardarPresupuesto();

    if (guardadoExitoso && id) {
      generarImpresionPresupuesto(id);
    }
  };

  const generarImpresionPresupuesto = (id: any) => {
    setLoading(true);
    apiFc
      .get(`/web/presupuestos/report/${id}`, {
        responseType: "blob",
      })
      .then((response) => {
        const fileURL = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = fileURL;
        link.setAttribute("download", `presupuesto_${id}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(fileURL);

        setAlertDialog({
          ...alertDialog,
          visible: true,
          cabecera: "Éxito",
          texto: "PDF generado correctamente",
          severity: "success",
        });
      })
      .catch((error) => {
        handleError("Error al generar el PDF");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Calcular totales
  const calcularTotales = () => {
    const subtotal =
      presupuesto.renglones?.reduce(
        (sum, item) => sum + item.productoPrecioLista * item.cantidad,
        0
      ) || 0;
    const total =
      subtotal * (1 - presupuesto.bonificacionGeneral / 100) +
      presupuesto.fletePrecio;
    return { subtotal, total };
  };

  const { subtotal, total } = calcularTotales();

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "50vh" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
      </div>
    );
  }

  const handleError = (message: string) => {
    setAlertDialog({
      ...alertDialog,
      visible: true,
      cabecera: "Error",
      texto: message,
      severity: "error",
    });
  };

  const handleBusqueda = (busqueda: respuestaBusqueda) => {
    if (busqueda.type === 1) {
      // Búsqueda normal
      setBusquedaProductos(busqueda.value);
      buscarProductos(busqueda.value);
    } else if (busqueda.type === 2) {
      // Cuando se selecciona un grupo
      setBusquedaProductos(busqueda.text);
      // Buscar productos del grupo
      apiFc.get(`/articuloGrupos/${busqueda.value}/articulos`)
        .then(res => setResultadosBusqueda(res.data))
        .catch(err => console.error(err));
    }
  };

  return (
    <div>
      {alertDialog.visible && <Mensaje></Mensaje>}
      <div className="breadcrumb-header justify-content-between">
        <div className="left-content">
          <span className="main-content-title mg-b-0 mg-b-lg-1">
            {id ? `Presupuesto ${id}` : "Nuevo Presupuesto"}
          </span>
        </div>
      </div>
      <Modal
        show={showModalProducto}
        onHide={() => {
          setShowModalProducto(false);
          setProductoEditando(null);
          setModoEdicion(false);
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {modoEdicion ? "Editar Producto" : "Agregar Producto"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!productoEditando ? (
            <>
              <div className="mb-3">
                <Form.Label>Buscar producto de ferretería</Form.Label>
                <BarraBusquedaSugerida
  onSearch={handleBusqueda}
  classNameContainer="input wd-100p"
  classNameInput="form-control"
  showSuggestions={true} // Asegúrate que las sugerencias estén habilitadas
/>
              </div>
              {resultadosBusqueda?.length > 0 && (
                <Table striped bordered hover className="mb-3">
                  <thead>
                    <tr>
                      <th>Código</th>
                      <th>Descripción</th>
                      <th>Precio</th>
                      <th>Stock</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resultadosBusqueda?.map((producto) => (
                      <tr
                        key={producto.articuloCodigo}
                        onClick={() => seleccionarProducto(producto)}
                        style={{ cursor: "pointer" }}
                      >
                        <td>{producto.articuloCodigo}</td>
                        <td>{producto.articuloDescripcion}</td>
                        <td>
                          {formatearPrecio({
                            valor: producto.articuloPrecio?.toFixed(2),
                          })}
                        </td>
                        <td className="text-center font-weight-bold tx-15">
                          <StockLevel
                            stock={producto.articuloStock}
                            stockMin={producto.articuloStockMin}
                            stockMax={producto.articuloStockMax}
                          />
                        </td>
                        <td>
                          <div className="d-flex gap-1">
                            <Button
                              variant="primary"
                              size="sm"
                              onClick={(e) => {
                                e.stopPropagation();
                                seleccionarProducto(producto, "sug1");
                              }}
                            >
                              {formatearPrecio({
                                valor: user?.clienteConfiguracionMostrarIVA
                                  ? producto.articuloPrecioVentaSug1 *
                                    (1 + producto.articuloTasaIVA / 100)
                                  : producto.articuloPrecioVentaSug1,
                              })}
                            </Button>
                            <Button
                              variant="primary"
                              size="sm"
                              onClick={(e) => {
                                e.stopPropagation();
                                seleccionarProducto(producto, "sug2");
                              }}
                            >
                              {formatearPrecio({
                                valor: user?.clienteConfiguracionMostrarIVA
                                  ? producto.articuloPrecioVentaSug2 *
                                    (1 + producto.articuloTasaIVA / 100)
                                  : producto.articuloPrecioVentaSug2,
                              })}
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
              <div className="text-center mt-3">
                <Button
                  variant="outline-secondary"
                  onClick={() => {
                    setProductoEditando({
                      codigo: "",
                      detalle: "",
                      precio: 0,
                      cantidad: 1,
                      esExterno: true,
                    });
                  }}
                >
                  Ingresar producto manualmente
                </Button>
              </div>
            </>
          ) : (
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>
                  Código {productoEditando.esExterno ? "" : ""}
                </Form.Label>
                <Form.Control
                  type="text"
                  className="text-dark"
                  value={productoEditando.codigo}
                  onChange={(e) =>
                    setProductoEditando({
                      ...productoEditando,
                      codigo: e.target.value,
                    })
                  }
                  disabled={!productoEditando.esExterno}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Descripción</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={productoEditando.detalle}
                  onChange={(e) =>
                    setProductoEditando({
                      ...productoEditando,
                      detalle: e.target.value,
                    })
                  }
                  className="text-dark"
                  disabled={!productoEditando.esExterno}
                />
              </Form.Group>
              <Row>
                <Col>
                  {/* {" "} */}
                  <Form.Group className="mb-3">
                    <Form.Label>Precio de Venta</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>$</InputGroup.Text>
                      <Form.Control
                        type="text"
                        ref={inputRef}
                        value={
                          editingPrice
                            ? priceInputValue
                            : (productoEditando.mostrarConIVA &&
                              productoEditando.iva
                                ? productoEditando.precio *
                                  (1 + productoEditando.iva / 100)
                                : productoEditando.precio
                              )
                                .toFixed(2)
                                .replace(".", ",")
                        }
                        onChange={(e) => {
                          const rawValue = e.target.value
                            .replace(/[^0-9,]/g, "")
                            .replace(/(,.*?),/g, "$1");
                          setPriceInputValue(rawValue);
                          if (rawValue.includes(",") || rawValue.length > 0) {
                            const numericValue =
                              parseFloat(rawValue.replace(",", ".")) || 0;
                            const precioSinIVA =
                              productoEditando.mostrarConIVA &&
                              productoEditando.iva
                                ? numericValue /
                                  (1 + productoEditando.iva / 100)
                                : numericValue;
                            setProductoEditando({
                              ...productoEditando,
                              precio: precioSinIVA,
                              precioSugeridoSeleccionado: undefined,
                            });
                          }
                        }}
                        onFocus={() => {
                          setEditingPrice(true);
                          setPriceInputValue(
                            (productoEditando.mostrarConIVA &&
                            productoEditando.iva
                              ? productoEditando.precio *
                                (1 + productoEditando.iva / 100)
                              : productoEditando.precio
                            )
                              .toString()
                              .replace(".", ",")
                          );
                        }}
                        onBlur={() => {
                          setEditingPrice(false);
                          const numericValue =
                            parseFloat(priceInputValue.replace(",", ".")) || 0;
                          const precioSinIVA =
                            productoEditando.mostrarConIVA &&
                            productoEditando.iva
                              ? numericValue / (1 + productoEditando.iva / 100)
                              : numericValue;
                          setProductoEditando({
                            ...productoEditando,
                            precio: precioSinIVA,
                          });
                        }}
                        className="text-dark"
                      />
                    </InputGroup>
                    {productoEditando.precioSugerido1 &&
                      productoEditando.precioSugerido2 && (
                        <div className="d-flex gap-2 mt-2">
                          <Button
                            variant={
                              productoEditando.precioSugeridoSeleccionado ===
                              "sug1"
                                ? "primary"
                                : "outline-primary"
                            }
                            size="sm"
                            onClick={() =>
                              setProductoEditando({
                                ...productoEditando,
                                precio: productoEditando.precioSugerido1!,
                                precioSugeridoSeleccionado: "sug1",
                              })
                            }
                          >
                            Usar SUG1:{" "}
                            {formatearPrecio({
                              valor: (productoEditando.mostrarConIVA &&
                              productoEditando.iva
                                ? productoEditando.precioSugerido1 *
                                  (1 + productoEditando.iva / 100)
                                : productoEditando.precioSugerido1
                              ).toFixed(2),
                            })}
                          </Button>
                          <Button
                            variant={
                              productoEditando.precioSugeridoSeleccionado ===
                              "sug2"
                                ? "primary"
                                : "outline-primary"
                            }
                            size="sm"
                            onClick={() =>
                              setProductoEditando({
                                ...productoEditando,
                                precio: productoEditando.precioSugerido2!,
                                precioSugeridoSeleccionado: "sug2",
                              })
                            }
                          >
                            Usar SUG2:{" "}
                            {formatearPrecio({
                              valor: (productoEditando.mostrarConIVA &&
                              productoEditando.iva
                                ? productoEditando.precioSugerido2 *
                                  (1 + productoEditando.iva / 100)
                                : productoEditando.precioSugerido2
                              ).toFixed(2),
                            })}
                          </Button>
                        </div>
                      )}
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Cantidad</Form.Label>
                    <Form.Control
                      type="number"
                      value={productoEditando.cantidad}
                      onChange={(e) =>
                        setProductoEditando({
                          ...productoEditando,
                          cantidad: parseInt(e.target.value) || 1,
                        })
                      }
                      min="1"
                      className="text-dark"
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Subtotal</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>$</InputGroup.Text>
                      <Form.Control
                        type="text"
                        readOnly
                        value={(() => {
                          const precioUnitario =
                            productoEditando.mostrarConIVA &&
                            productoEditando.iva
                              ? productoEditando.precio *
                                (1 + productoEditando.iva / 100)
                              : productoEditando.precio;
                          const subtotal =
                            precioUnitario * productoEditando.cantidad;
                          return formatearPrecio({
                            valor: subtotal.toFixed(2),
                          });
                        })()}
                        className="text-dark"
                      />
                    </InputGroup>
                  </Form.Group>
                  {/* <div className="border-top pt-2 mt-3"></div> */}
                </Col>
              </Row>
            </Form>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowModalProducto(false)}
          >
            Volver
          </Button>
          {productoEditando && (
            <Button variant="primary" onClick={guardarProducto}>
              {modoEdicion ? "Actualizar" : "Agregar"} Producto
            </Button>
          )}
        </Modal.Footer>
      </Modal>
      <Card>
        <Card.Body>
          {error && (
            <Alert variant="danger" dismissible onClose={() => setError(null)}>
              {error}
            </Alert>
          )}
          {success && (
            <Alert
              variant="success"
              dismissible
              onClose={() => setSuccess(null)}
            >
              {success}
            </Alert>
          )}
          <Row className="mb-4">
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Descripción</Form.Label>
                <Form.Control
                  type="text"
                  className="text-dark"
                  value={presupuesto.descripcion}
                  onChange={(e) =>
                    setPresupuesto({
                      ...presupuesto,
                      descripcion: e.target.value,
                    })
                  }
                  placeholder="Descripcion presupuesto"
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Cliente</Form.Label>
                <Form.Control
                  type="text"
                  className="text-dark"
                  value={presupuesto.clienteDescripcion}
                  onChange={(e) =>
                    setPresupuesto({
                      ...presupuesto,
                      clienteDescripcion: e.target.value,
                    })
                  }
                  placeholder="Buscar cliente..."
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group className="mb-3">
                <Form.Label>Fecha Creación</Form.Label>
                <Form.Control
                  className="text-dark"
                  type="date"
                  value={presupuesto.fechaCreacion}
                  onChange={(e) =>
                    setPresupuesto({
                      ...presupuesto,
                      fechaCreacion: e.target.value,
                    })
                  }
                  disabled={!!id} // Deshabilitado para presupuestos existentes
                />
              </Form.Group>
            </Col>
            <Form.Group className="mb-3">
              <Form.Label>Fecha Validez</Form.Label>
              <Form.Control
                className="text-dark"
                type="date"
                value={presupuesto.fechaValidez}
                onChange={(e) =>
                  setPresupuesto({
                    ...presupuesto,
                    fechaValidez: e.target.value,
                  })
                }
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Estado del Presupuesto</Form.Label>
              <Select
                options={estadoOptions}
                value={selectedOption}
                onChange={(selected) => {
                  if (selected) {
                    const estadoSeleccionado = estado.find(
                      (est) => est.id === selected.value
                    );
                    if (estadoSeleccionado) {
                      setPresupuesto({
                        ...presupuesto,
                        estado: estadoSeleccionado,
                      });
                    }
                  }
                }}
                isDisabled={loading || !id}
                placeholder="Seleccione un estado"
                noOptionsMessage={() => "No hay opciones disponibles"}
                classNamePrefix="select"
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: "38px",
                    borderColor: "#dee2e6",
                    "&:hover": {
                      borderColor: "#dee2e6",
                    },
                  }),
                  // option: (base, { data }) => ({
                  //   ...base,
                  //   color: !estado.find(e => e.id === data.value)?.activo ? '#999' : base.color,
                  // })
                }}
              />
            </Form.Group>
          </Row>
          <Card className="mb-4">
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5>Productos</h5>
              <div className="d-flex gap-2">
                <Button
                  variant="primary"
                  onClick={() => {
                    setProductoEditando(null);
                    setModoEdicion(false);
                    setBusquedaProductos("");
                    setResultadosBusqueda([]);
                    setShowModalProducto(true);
                  }}
                >
                  + Producto Ferretera
                </Button>
                <Button
                  variant="outline-primary"
                  onClick={() => {
                    setProductoEditando({
                      codigo: "",
                      detalle: "",
                      precio: 0,
                      cantidad: 1,
                      esExterno: true,
                    });
                    setModoEdicion(false);
                    setShowModalProducto(true);
                  }}
                >
                  + Otro Producto
                </Button>
              </div>
            </Card.Header>
            <Card.Body>
              <div className="table-responsive">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th className="text-center">Código</th>
                      <th className="text-center">Descripción</th>
                      <th className="text-center">Precio Unit.</th>
                      <th className="text-center">Cantidad</th>
                      <th className="text-center">Subtotal</th>
                      <th className="text-center">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {presupuesto?.renglones?.length === 0 ? (
                      <tr>
                        <td colSpan={6} className="text-center text-muted py-4">
                          No hay productos en el presupuesto
                        </td>
                      </tr>
                    ) : (
                      presupuesto?.renglones?.map((item) => {
                        // Buscar el producto completo para obtener la tasa de IVA
                        const productoCompleto =
                          resultadosBusqueda.find(
                            (p) => p.articuloCodigo === item.articuloCodigo
                          ) ||
                          presupuesto.renglones.find((p) => p.id === item.id);

                        const iva =
                          productoCompleto?.articuloTasaIVA ||
                          productoCompleto?.iva ||
                          0;
                        const mostrarConIVA =
                          user?.clienteConfiguracionMostrarIVA;

                        const precioUnitario = mostrarConIVA
                          ? item.productoPrecioLista * (1 + iva / 100)
                          : item.productoPrecioLista;

                        const subtotal = precioUnitario * item.cantidad;

                        return (
                          <tr key={item.id}>
                            <td>
                              {item.articuloCodigo ||
                                item.productoCodigo ||
                                "Sin codigo"}
                            </td>
                            <td>{item.productoDetalle}</td>
                            <td className="text-end">
                              {formatearPrecio({
                                valor: precioUnitario.toFixed(2),
                              })}
                            </td>
                            <td className="text-end">{item.cantidad}</td>
                            <td className="text-end">
                              {formatearPrecio({
                                valor: subtotal.toFixed(2),
                              })}
                            </td>

                            <td className="text-end" style={{ width: "15%" }}>
                              {" "}
                              <div className="d-flex justify-content-end align-items-center gap-1 w-100">
                                {item.articuloCodigo && (
                                  <div
                                    className="me-1"
                                    style={{ width: "60%" }}
                                  >
                                    {" "}
                                    <InputCarritoCompra
                                      articulo={{
                                        articuloCodigo: item.articuloCodigo,
                                        articuloComercializacionTipo: {
                                          articuloComercializacionTipoId: 1,
                                          articuloComercializacionTipoDetalle:
                                            "Ferretería",
                                        },
                                      }}
                                      origen="presupuestador"
                                      onEvent={(e: any) => setAlertDialog(e)}
                                    />
                                  </div>
                                )}

                                <div className="d-flex gap-1">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Editar</Tooltip>}
                                  >
                                    <Button
                                      variant="primary"
                                      size="sm"
                                      className="rounded-11 p-1"
                                      onClick={() => editarProducto(item)}
                                    >
                                      <i>
                                        <svg
                                          className="table-edit"
                                          xmlns="http://www.w3.org/2000/svg"
                                          height="20"
                                          viewBox="0 0 24 24"
                                          width="16"
                                        >
                                          <path
                                            d="M0 0h24v24H0V0z"
                                            fill="none"
                                          />
                                          <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z" />
                                        </svg>
                                      </i>
                                    </Button>
                                  </OverlayTrigger>

                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Eliminar</Tooltip>}
                                  >
                                    <Button
                                      variant="primary"
                                      size="sm"
                                      className="rounded-1 p-1"
                                      onClick={() => eliminarProducto(item.id)}
                                      disabled={eliminandoRenglon === item.id}
                                    >
                                      {eliminandoRenglon === item.id ? (
                                        <span
                                          className="spinner-border spinner-border-sm"
                                          role="status"
                                          aria-hidden="true"
                                        ></span>
                                      ) : (
                                        <svg
                                          className="table-delete"
                                          xmlns="http://www.w3.org/2000/svg"
                                          height="20"
                                          viewBox="0 0 24 24"
                                          width="16"
                                        >
                                          <path
                                            d="M0 0h24v24H0V0z"
                                            fill="none"
                                          />
                                          <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4h-3.5z" />
                                        </svg>
                                      )}
                                    </Button>
                                  </OverlayTrigger>
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>

          {/* Totales y observaciones, repasar esta parte cuando se genere el reporte */}
          <Row>
            <Col md={8}>
              <Form.Group className="mb-3">
                <Form.Label>Observaciones (visibles al cliente)</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={presupuesto.observacionPie}
                  onChange={(e) =>
                    setPresupuesto({
                      ...presupuesto,
                      observacionPie: e.target.value,
                    })
                  }
                  placeholder="Información adicional para el cliente..."
                  className="custom-textarea text-dark"
                />
              </Form.Group>

              <Form.Group>
                <Form.Label>Notas Internas</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={presupuesto.observacionInterna || ""}
                  onChange={(e) =>
                    setPresupuesto({
                      ...presupuesto,
                      observacionInterna: e.target.value,
                    })
                  }
                  placeholder="Notas para uso interno..."
                  className="custom-textarea"
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Card className="border-primary">
                <Card.Header className="bg-light">
                  <strong>Importes</strong>
                </Card.Header>
                <Card.Body className="p-0">
                  <Table borderless className="mb-0">
                    <tbody>
                      <tr className="border-bottom">
                        <td className="p-3">
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="fw-medium">Subtotal:</span>
                            <span className="text-end">
                              {formatearPrecio({
                                valor: subtotal?.toFixed(2),
                              })}
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr className="border-bottom">
                        <td className="p-3">
                          <div className="mb-2">
                            <div className="d-flex justify-content-between align-items-center mb-1">
                              <span className="fw-medium">Bonificación:</span>
                              <span className="text-end text-success ">
                                -
                                {formatearPrecio({
                                  valor: (
                                    (subtotal *
                                      presupuesto.bonificacionGeneral) /
                                    100
                                  )?.toFixed(2),
                                })}
                              </span>
                            </div>
                          </div>
                          <InputGroup size="sm">
                            <Form.Control
                              type="number"
                              value={presupuesto.bonificacionGeneral}
                              onChange={(e) => {
                                const value = parseFloat(e.target.value);
                                if (value >= 0 && value <= 100) {
                                  setPresupuesto({
                                    ...presupuesto,
                                    bonificacionGeneral: value,
                                  });
                                }
                              }}
                              min="0"
                              max="100"
                              className="text-end text-dark"
                            />
                            <InputGroup.Text>%</InputGroup.Text>
                          </InputGroup>
                        </td>
                      </tr>
                      <tr className="border-bottom">
                        <td className="p-3">
                          <div className="mb-2">
                            <div className="d-flex justify-content-between align-items-center mb-1">
                              <span className="fw-medium">Flete:</span>
                              <span className="text-end">
                                {formatearPrecio({
                                  valor: presupuesto.fletePrecio?.toFixed(2),
                                })}
                              </span>
                            </div>
                          </div>
                          <InputGroup size="sm">
                            <InputGroup.Text>$</InputGroup.Text>
                            <Form.Control
                              type="number"
                              value={presupuesto.fletePrecio || ""}
                              onChange={(e) => {
                                const rawValue = e.target.value;
                                // Permite números, punto decimal y vacío
                                if (
                                  rawValue === "" ||
                                  /^[0-9]*\.?[0-9]*$/.test(rawValue)
                                ) {
                                  setPresupuesto({
                                    ...presupuesto,
                                    fletePrecio:
                                      rawValue === ""
                                        ? null
                                        : parseFloat(rawValue),
                                  });
                                }
                              }}
                              onBlur={() => {
                                // Formatea solo cuando pierde el foco
                                if (presupuesto.fletePrecio !== null) {
                                  setPresupuesto({
                                    ...presupuesto,
                                    fletePrecio: parseFloat(
                                      presupuesto.fletePrecio.toFixed(2)
                                    ),
                                  });
                                }
                              }}
                              min="0"
                              step="0.01"
                              className="text-end text-dark"
                              placeholder="0.00"
                            />
                          </InputGroup>
                        </td>
                      </tr>
                      <tr>
                        <td className="p-3 bg-light">
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="fw-bold">TOTAL:</span>
                            <span className="text-end fw-bold fs-5">
                              {formatearPrecio({
                                valor: total?.toFixed(2),
                              })}
                            </span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Card.Body>

        <Card.Footer className="d-flex justify-content-between">
          <Button
            variant="secondary"
            onClick={() => navigate("/principal/presupuestador")}
          >
            Volver
          </Button>
          <div>
            <Button
              variant="primary"
              className="me-2"
              onClick={guardarPresupuesto}
              disabled={loading}
            >
              {loading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              ) : (
                "Guardar"
              )}
            </Button>
            <Button
              variant="success"
              onClick={guardarEImprimir}
              disabled={loading}
            >
              {loading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              ) : (
                "Guardar e Imprimir"
              )}
            </Button>
          </div>
        </Card.Footer>
      </Card>
    </div>
  );
};

export default PresupuestadorEdicion;
